import { Field, FieldError, FieldLabel } from "@shared/ui/field";
import { Input } from "@shared/ui/input";
import { useFieldContext } from "../form";

export type TextFieldProps = React.ComponentProps<"input"> & {
	label: string;
	required?: boolean;
};

export function TextField({ label, required }: TextFieldProps) {
	const field = useFieldContext();
	const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

	return (
		<Field data-invalid={isInvalid}>
			<FieldLabel htmlFor={field.name} className="gap-1">
				{label} {required && <span className="text-destructive">*</span>}
			</FieldLabel>
			<Input
				id={field.name}
				name={field.name}
				value={field.state.value as string}
				onBlur={field.handleBlur}
				onChange={(e) => field.handleChange(e.target.value)}
				aria-invalid={isInvalid}
				autoComplete="off"
			/>
			{isInvalid && <FieldError errors={field.state.meta.errors} />}
		</Field>
	);
}
